import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { auth0Locales } from '../../i18n';
import { useLanguage } from '../../i18n/LanguageProvider';
import { LoadingSpinner } from '../shared/LoadingSpinner';
import { TokenService } from './TokenService';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { language } = useLanguage();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const waitForToken = async () => {
      await new Promise<void>(resolve => {
        const interval = setInterval(() => {
          const token = TokenService.getToken();
          if (token) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
      setIsReady(true);
    };
    waitForToken();
  }, [setIsReady]);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        authorizationParams: { ui_locales: auth0Locales[language] },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, language]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated && isReady ? (
    <div style={{ padding: '32px' }}>{children}</div>
  ) : null;
};
